/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/forbid-prop-types */
import React, { useContext } from 'react';
import Breadcrumbs from 'gatsby-core-theme/src/components/atoms/breadcrumbs';
import { Context } from 'gatsby-core-theme/src/context/MainProvider';
import { getSectionExtraField } from 'gatsby-core-theme/src/helpers/getters';
import DefaulTemplateTwo from 'gatsby-matrix-theme/src/components/molecules/header/variants/default/template-two';
import DefaulTemplateOne from 'gatsby-core-theme/src/components/molecules/header/variants/default/template-one';

import AuthorTemplate from 'gatsby-matrix-theme/src/components/molecules/header/variants/author/template-one';
import OperatorTemplateOne from 'gatsby-core-theme/src/components/molecules/header/variants/operator/template-one-two/index';
import PaymentTemplateOne from 'gatsby-matrix-theme/src/components/molecules/header/variants/payment/template-one-three/index';
import GameTemplateOne from 'gatsby-matrix-theme/src/components/molecules/header/variants/slot/template-one';

import VerifiedAuthor from 'gatsby-matrix-theme/src/images/icons/verified-author';
import styles from './header.module.scss';

export default function Header({ section, numOfStarsRating = 5 }) {
  const { bannerIsActive } = useContext(Context) || {};
  const customStyles = section.page.path === '/' ? 'homepage' : section.page.path.replace('/', '-');
  const lottoUk49 = section?.page.categories?.find(res => res.name === 'lotto uk 49') || false;
  const relationContent = (pageSection, starratings) => {

    let ModuleComponent = null;
    switch (pageSection?.page?.relation_type) {
      case 'payment_method': {
        const { page } = pageSection || {};
        const { market, relation } = page || {};

        const marketsDataPaymentRatings = (relation?.markets_data !== undefined && relation?.markets_data[market] !== undefined) &&
          Object.keys(relation?.markets_data[market])
            .filter(key => relation?.markets_data[market] !== null && relation?.markets_data[market][key] !== '' && relation?.markets_data[market][key]?.length > 0)
            .reduce((acc, key) => {
              acc[key] = relation?.markets_data[market][key];
              return acc;
            }, {});

        if (marketsDataPaymentRatings && Object.values(marketsDataPaymentRatings).length) {
          // override general ratings with markets data ratings
          page.relation = {
            ...page.relation,
            ...marketsDataPaymentRatings,
          }
        }

        const data = {
          page: pageSection?.page,
          relation: pageSection?.page?.relation || {},
          type: pageSection?.page?.relation_type,
          template: pageSection?.page?.page_styles?.short_name,
          pageTemplate: pageSection?.page?.template,
          pageSections: pageSection?.page?.pageSections,
          name: pageSection?.page?.title || pageSection?.page?.relation?.name,
          ribbons: pageSection?.page?.relation?.ribbons || [],
          image: pageSection?.page?.relation?.logo,
          numOfStars: 5,
          description:
            pageSection.page.description ||
            getSectionExtraField(null, pageSection.page.sections.header, 'header_text'),
        };
        return <PaymentTemplateOne {...data} />;
      }
      case 'operator': {
        const data = {
          page: pageSection?.page,
          author: pageSection?.page.author,
          type: pageSection?.page?.relation_type,
          template: pageSection?.page?.page_styles?.short_name,
          pageTemplate: pageSection?.page?.template,
          relation: pageSection?.page?.relation || {},
          name: pageSection?.page?.title || pageSection?.page?.relation?.name,
          ribbons: pageSection?.page?.relation?.ribbons || [],
          image: pageSection?.page?.relation?.logo,
          featureImg: pageSection?.page?.featured_image_object,
          extraFields: pageSection?.page?.extra_fields || {},
          numOfStars: starratings,
        };
        return <OperatorTemplateOne {...data} />;
      }
      case 'game': {
        const { page } = pageSection || {};
        const { market, relation } = page || {};
        const { affiliate_games: affiliateGames, markets } = relation;

        // get ratings from site data or market data before general data, only get the props with values
        const sitesDataGameRatings = affiliateGames && (!Array.isArray(affiliateGames[market]?.extra_fields) && affiliateGames[market]?.extra_fields) && 
          Object.keys(affiliateGames[market]?.extra_fields)
          .filter(key => affiliateGames[market]?.extra_fields[key] !== null && affiliateGames[market]?.extra_fields[key] !== '')
          .reduce((acc, key) => {
            acc[key] = affiliateGames[market]?.extra_fields[key];
            return acc;
          }, {});
        const marketsDataGameRatings = markets && (!Array.isArray(markets) && markets[market]) && Object.keys(markets[market])
          .filter(key => markets[market][key] !== null && markets[market][key] !== '')
          .reduce((acc, key) => {
            acc[key] = markets[market][key];
            return acc;
        }, {});

        if (marketsDataGameRatings && Object.values(marketsDataGameRatings).length) {
          // override general ratings with markets data ratings
          page.relation = {
            ...page.relation,
            ...marketsDataGameRatings,
          }
        }
        if (sitesDataGameRatings && Object.values(sitesDataGameRatings).length) {
          // override markets data ratings with sites data ratings
          page.relation = {
            ...page.relation,
            ...sitesDataGameRatings,
          }
        }

        return <GameTemplateOne page={pageSection.page} image={<VerifiedAuthor />} />;
      }
      case 'author': {
        if (!pageSection.page.relation) {
          return <></>;
        }

        return (
          <AuthorTemplate
            author={pageSection.page.relation}
            authorTitle={pageSection?.page?.title}
          />
        );
      }
      default:
        return ModuleComponent;
    }
  };

  const getDefaultHeader = () => {
    const props = {
      page: section.page,
      extraFields: section.page.extra_fields,
      imageObj: section.page.featured_image_object,
      title: section.page.title,
      description:
        section.page.description ||
        getSectionExtraField(null, section.page.sections?.header, 'header_text'),
    };
    let ModuleComponent = null;

   
    if (section?.page?.page_styles?.short_name === 'template_two') {
      ModuleComponent = DefaulTemplateTwo;
    } else {
        ModuleComponent = DefaulTemplateOne;
    }
    return <ModuleComponent {...props} />;
  };

  return (
    <header
      className={`${styles?.header || ''}
        ${lottoUk49 ? styles.lotto_uk_49 : ''} 
        ${styles[section.page.template] ? styles[section.page.template] || '' : ''}
        ${styles[section.page.relation_type] ? styles[section.page.relation_type] || '' : ''}
        ${
          section?.page?.page_styles && styles[section?.page?.page_styles?.short_name]
            ? styles[section?.page?.page_styles?.short_name] || ''
            : ''
        } 
        ${bannerIsActive && styles.bannerIsActive ? styles.bannerIsActive : ''}
        ${styles[customStyles] ? styles[customStyles] || '' : ''}
        `}
    >
      {section.page.path && <Breadcrumbs markets={section.allMarkets} page={section.page} />}
      {section?.page?.relation_type === 'page' ||
      section?.page?.relation_type === 'software_provider' ||
      section?.page?.relation_type === 'article'
        ? getDefaultHeader()
        : relationContent(section, numOfStarsRating)}
    </header>
  );
}
